import * as React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { InviewProps } from '../blocksState'
import {
  RelatedContentBlockLayout
} from './relatedContentBlockLayout'
import {
  RelatedContent,
  RelatedContentBlockState
} from './relatedContentBlockState'

export type RelatedContentBlock = {
  index: number
  inview?: InviewProps
  relatedContentBlockState: RelatedContentBlockState
  filter: RelatedContentFilter
}

export type RelatedContentFilter =
  | {
      source: 'department'
      department: string
    }
  | {
      source: 'specialist'
      specialist: string
    }
  | {
      source: 'tags'
      tags: string[]
    }

export const relatedContentBlockWidget = (
  block: RelatedContentBlock,
): Widget<Updater<RelatedContentBlockState>> =>
  async<RelatedContent>(block.relatedContentBlockState, (relatedContent) =>
    fromJSX(() => (
      <RelatedContentBlockLayout
        index={block.index}
        teasers={relatedContent.map((item) => ({
          url: `/${item.type === 'news' ? 'nieuws' : 'agenda'}${item.slug}`,
          title: item.headerTitle,
          intro: item.intro,
          img: item.img,
          eventDate: item.eventDate ? new Date(item.eventDate) : undefined,
        }))}
        readMoreUrl={`/nieuws-en-agenda?${
          block.filter.source === 'department'
            ? `department=${block.filter.department}`
            : block.filter.source === 'specialist'
            ? `specialist=${block.filter.specialist}`
            : block.filter.tags.map((tag) => `tags=${tag}`).join('&')
        }`}
      />
    ))
  )
